import { gql } from '@apollo/client';

export const updatePerson = gql`
  mutation updatePerson($person: PersonUpdateInput!) {
    updatePerson(person: $person) { 
      id
      firstName middleName lastName
      email emailOptIn phone phoneOptIn
      defaultBuyerId
    }
  }`;

export const getPersonByEmail = gql`
  query getPersonByEmail($email: String) {
    person(email: $email) {
      id
      buyers { buyer { id } }
    }
  }`;
